import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  company: [],
  vacancy: []
}

const resetCategories = (item) => {
  item.checked = false
  if (item.children.length > 0) {
    item.children.map((child) => {
      child.checked = false
      return child
    })
  }
  return item
}

const categoriesInitializeMap = (item, payload) => {
  item = resetCategories(item)

  if (payload.indexOf(item.id.toString()) > -1) {
    item.checked = true
    if (item.children.length > 0) {
      item.children.map((child) => {
        child.checked = true
        return child
      })
    }
  } else {
    if (item.children.length > 0) {
      item.children.map((child) => {
        if (payload.indexOf(child.id.toString()) > -1) {
          child.checked = true
        }
        return child
      })
    }
  }
  return item
}

const categoriesMap = (item, payload) => {
  if (item.id === payload.parentId && payload.categoryId === -1) {
    item.checked = typeof payload.status === 'undefined'
      ? !item.checked : payload.status
    if (item.children.length > 0) {
      item.children.map((child) => {
        child.checked = typeof payload.status === 'undefined'
          ? item.checked : payload.status
        return child
      })
    }
  } else {
    if (item.children.length > 0) {
      item.children.map((child) => {
        if (child.id === payload.categoryId) {
          child.checked = typeof payload.status === 'undefined'
            ? !child.checked : payload.status
        }
        return child
      })
    }
  }
  return item
}

const categoriesReduce = (data = []) => {
  return data.reduce((categories, item) => {
    item.checked = false
    if (item.children.length > 0) {
      item.children.map((child) => {
        child.checked = false
        return child
      })
    }
    return categories.concat(item)
  }, [])
}

const mutations = {
  [types.INITIALIZE_COMPANY_CATEGORY] (state, data) {
    state.company.map((item) => {
      return categoriesInitializeMap(item, data)
    })
  },
  [types.INITIALIZE_VACANCY_CATEGORY] (state, data) {
    state.vacancy.map((item) => {
      return categoriesInitializeMap(item, data)
    })
  },
  [types.TOGGLE_COMPANY_CATEGORY] (state, payload) {
    state.company.map((item) => {
      return categoriesMap(item, payload)
    })
  },
  [types.TOGGLE_VACANCY_CATEGORY] (state, payload) {
    state.vacancy.map((item) => {
      return categoriesMap(item, payload)
    })
  },
  [types.RESET_COMPANY_CATEGORY] (state) {
    state.company.map((item) => {
      return resetCategories(item)
    })
  },
  [types.RESET_VACANCY_CATEGORY] (state) {
    state.vacancy.map((item) => {
      return resetCategories(item)
    })
  },
  [types.COMPANY_CATEGORIES] (state, data) {
    state.company = categoriesReduce(data)
  },
  [types.VACANCY_CATEGORIES] (state, data) {
    state.vacancy = categoriesReduce(data)
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/categories/store.js